import { useAuthContext } from "./authContext";
import { track, getCurrentWave } from "../analytics/posthog";

export function useAuth() {
  const { session, authLoading, auth, wave, isAdmin } = useAuthContext();
  return {
    session,
    loading: authLoading,
    wave,
    isAdmin,
    signOut: () => {
      track("logout", { wave: getCurrentWave() });
      return auth.signOut().then(() => {
        window.location.replace("/");
      });
    },
    signInWithMagicLink: (email: string, redirectTo?: string) => auth.signInWithMagicLink(email, redirectTo),
    signInWithGoogle: () => auth.signInWithGoogle(),
  };
}
